import styled, { css } from 'styled-components';
import { Icon as IconComponent } from '../index';

export const Container = styled.div(
  ({ theme }) => css`
    border-radius: ${theme.bo.medium};
    padding: ${theme.sz.s4};
    background: ${theme.co.neutral99};
    max-width: 100%;

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s4};
    }
  `,
);

export const Row = styled.div(
  ({ theme }) => css`
    gap: ${theme.sz.s2};
    display: grid;
    grid-template-columns: ${theme.sz.s24} auto 0fr;
    align-items: center;

    @media (max-width: ${theme.sz.md}) {
      grid-template-columns: ${theme.sz.s20} auto 0fr;
    }
  `,
);

export const Label = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    padding: 0 ${theme.sz.s2} ${theme.sz.s2} 0;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.xxxs};
    }
  `,
);

export const Number = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xs};
    padding-right: ${theme.sz.s1};
    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.xs};
    }
  `,
);

export const Days = styled.div<{ $disabled: boolean }>(
  ({ theme, $disabled }) => css`
    ${theme.typography.paragraph.base};
    display: flex;
    padding-right: ${theme.sz.s2};
    align-items: center;
    color: ${$disabled && theme.co.secondary50};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.s};
    }
  `,
);

export const Divider = styled.div(
  ({ theme }) => css`
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary90};
    padding-top: ${theme.sz.s3};
    margin-bottom: ${theme.sz.s3};
  `,
);

export const StreakIcon = styled(IconComponent)(
  ({ theme }) => css`
    svg {
      width: ${theme.sz.s8};
      height: ${theme.sz.s8};
    }
  `,
);

export const EmptyStreakIcon = styled(StreakIcon)(
  () => css`
    visibility: hidden;
  `,
);

export const NoStreakIcon = styled(IconComponent)(
  ({ theme }) => css`
    color: ${theme.co.secondary90};
    padding-left: ${theme.sz.s2};
    font-size: ${theme.sz.s6};
  `,
);

export const EmptyNoStreakIcon = styled(NoStreakIcon)(
  ({ theme }) => css`
    font-size: ${theme.sz.s6};
    visibility: hidden;
  `,
);
